import React from 'react';
import '../css/ManualCheckout.css';
import { url } from '../env.json';
const axios = require('axios');

export default class ManualCheckout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // renderState can be scan, or success
            // default is 'scan'
            renderState: 'scan',
            msgDisplay: 'none',
            maxCupsDisplay: 'none',
            checkoutErrDisplay: 'none',
            vendorName: ''
        }
    }

    renderScan() {
        let checkoutMsgStyle = {
            color: 'red',
            fontSize: '120%',
            marginBottom: '5px',
            padding: '10px',
            display: this.state.msgDisplay
        }

        let checkoutErrMsgStyle = {
            color: 'red',   
            margin: '5px',
            padding: '10px',
            display: this.state.checkoutErrDisplay
        }

        let maxCupsMsgStyle = {
            color: 'red',   
            margin: '5px',
            padding: '10px',
            display: this.state.maxCupsDisplay
        }

        return (
            <div className="app-page" id="manual-checkout-page">
                <h1>Manual Checkout</h1>
                <img alt='' id="vendor-code-img" src="https://cuppy-assets.s3-us-west-2.amazonaws.com/VendorCode-Web.png"/>
                <div style={checkoutMsgStyle} id="checkout-msg">
                    Please enter a valid vendor code!<br/>
                    Vendor codes are 4 digits.
                </div>
                <input id="vendorcode-input" autoComplete="off" ref="vendorCode" className="vendor-code-input" type="number" placeholder="E.g. 1234" name="vendorcode" required></input>
                <button ref='scbtn' id="self-checkout-btn" onClick={() => {
                    let vendorID = this.refs.vendorCode.value;

                    if (vendorID === '' || vendorID.length < 4) {
                        this.setState({
                            msgDisplay: 'block'
                        })
                    } else {
                        this.refs.scbtn.setAttribute('disabled', 'disabled');
                        axios.post(url + '/checkoutScan', {
                            message: 'checkout',
                            userID: this.props.userID,
                            location: vendorID
                        })
                        .then((resp) => {
                            this.refs.scbtn.removeAttribute('disabled');
                            // console.log(resp.data)
                            if (resp.data.status === 'SUCCESS') {
                                this.setState({
                                    renderState: 'success',
                                    msgDisplay: 'none',
                                    checkoutErrDisplay: 'none',
                                    vendorName: resp.data.vendorName
                                })
                            } else if (resp.data.error.includes('MAX')) {
                                this.setState({
                                    msgDisplay: 'none',
                                    maxCupsDisplay: 'block',
                                    checkoutErrDisplay: 'none'
                                })
                            } else {
                                this.setState({
                                    msgDisplay: 'none',
                                    maxCupsDisplay: 'none',
                                    checkoutErrDisplay: 'block'  
                                })
                            }
                        })
                    }
                }}>CHECK OUT</button>
                <div id="checkout-err-msg" style={checkoutErrMsgStyle}>There was an error during checkout. Please double check the vendor code or try again later.</div>
                <div id="max-cups-msg" style={maxCupsMsgStyle}>Sorry, you have already checked out the maximum number of cups.</div>
                <button id="cancel-manual-checkout-btn" onClick={() => {this.props.cancelManualCheckout()}}>&lt; Cancel</button>
            </div>
        )
    }

    scanSuccess() {
        let today = new Date();
        let date = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();
        let time = today.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})

        let headerStyle = {
            color: 'green',
            fontWeight: '900',
            fontSize: '275%'
        }

        return(
            <div className="app-page" id="man-scan-success-page">
                <h1 style={headerStyle}>Checkout Success!</h1>
                <div id="vendor-name-container">{this.state.vendorName}</div>
                <div id="date-container">{date}</div>
                <div id="time-container">{time}</div>
                <img alt='' id="scan-success-img" src="https://cuppy-assets.s3-us-west-2.amazonaws.com/logo-gray.png"/>
                <div id="success-checkout-msg">Please show this to the barista and have them confirm your checkout.</div>
                <button id="confirm-checkout-btn" onClick={() => {this.props.cancelManualCheckout()}}>CONFIRMED</button>
            </div>
        )
    }

    render() {
        if (this.state.renderState === 'scan') {
            return this.renderScan();
        } else if (this.state.renderState === 'success') {
            return this.scanSuccess();
        }
    }
}